// Unpublished Work © 2020 Deere & Company

import t from 'tcomb';

export const AddressElement = t.struct({
    enabled: t.Boolean,
    id: t.Number,
    label: t.maybe(t.String),
    required: t.Boolean
}, {
    defaultProps: {
        enabled: true,
        id: 0,
        label: '',
        required: false
    },
    name: 'AddressElement',
    strict: true
});

export const AddressElements = t.dict(t.String, AddressElement, 'AddressElements');
